var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDateIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B7D523",
  d: "M48 40H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8h40z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#21241E",
  d: "M20 10v3M28 10v3M15.5 17.09h17M33 16.5V25c0 3-1.5 5-5 5h-8c-3.5 0-5-2-5-5v-8.5c0-3 1.5-5 5-5h8c3.5 0 5 2 5 5ZM23.996 21.7h.005M20.297 21.7h.005M20.297 24.7h.005"
})));
export { SvgDateIcon as ReactComponent };
export default __webpack_public_path__ + "23c2ee6a80867e685c3e2ca3f5a275d8.svg";